type TFortnite =
|'name'
|'maps.c2_s6_fortnite_map'
;
const FortniteNS = 'fortnite';
function FortniteF(_: TFortnite): string { return `${FortniteNS}:${_}`; }
export {FortniteF,FortniteNS,TFortnite};
